import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import Footer from './Footer';
import berryClubLogo from '../images/berryClubLogo.jpg';
import bookImage from '../images/book_img.jpg';

// Custom Button Component
const CustomButton = ({ children, onClick, className = '', type = 'button' }) => {
  return (
    <button 
      type={type}
      onClick={onClick}
      className={`
        px-6 xs:px-7 sm:px-8 md:px-12 
        py-2 
        bg-white 
        rounded-full 
        text-black 
        text-sm xs:text-base
        font-medium 
        font-roboto 
        transition-all 
        border-2
        border-[#8b123b]
        hover:bg-[#8b123b] 
        hover:text-white
        hover:border-[#8b123b]
        ${className}
      `}
    >
      {children}
    </button>
  );
};

const BerryClubLanding = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email');
      return;
    }

    try {
      const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfr2i5aWZbkTylRafkSoCAf7p0XgG8k7V8DKkusmj54mgJQHg/formResponse';
      
      const formBody = new FormData();
      formBody.append('entry.1163189323', email);
      formBody.append('entry.204177542', 'Source-Berry Club Website-Interested Customer');

      await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: formBody,
      });

      setIsSubmitted(true);
      setEmail('');
      setError('');
    } catch (error) {
      console.error('Submission error:', error);
      setError('There was an error submitting your email. Please try again.');
    }
  };

  return (
    <div className="">
      <header className="fixed top-0 left-0 right-0 bg-[#212429] z-50 py-4 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="w-56 md:w-56">
            <img 
              src={berryClubLogo} 
              alt="Berry Club Logo" 
            />
          </div>
        </div>
      </header>
      <main className="flex-grow bg-[#212429] pt-8">
        <div className="py-8">
          <div className="max-w-4xl mx-auto px-4">
            <div className="mb-16 text-center">
              <h2 className="text-3xl md:text-4xl text-[#ffffff] mb-16 mt-16">
                Building phygital ecosystems that power modern consumer experiences.
              </h2>
            </div>

            <div className="relative bg-[#8b123b] text-white rounded-[40px] p-4 md:p-4 shadow-2xl overflow-hidden mb-5">
              <div className="absolute inset-0 bg-cover bg-opacity-10 bg-center z-0" style={{ backgroundImage: `url(${bookImage})` }}>
                <div className="absolute inset-0 bg-[#000000] bg-opacity-65"></div>
              </div>
              <div className="relative z-10 max-w-3xl mx-auto">
                <div className="flex justify-end mb-12">
                  <span className="text-4xl text-white">bookberry</span><span className="text-4xl text-[#e3cc6f] font-bold">.club</span>
                </div>
                <h3 className="text-2xl md:text-3xl mb-5 font-bold text-white">Powering the Reading Ecosystem</h3>
                <p className="text-xl mb-12 text-gray-200">
                  Bookberry.club connects readers, bookstores, and publishers through smart technology, community, purpose built programs, and rewards — making reading more accessible, social, and rewarding.
                </p>
                <p className="text-xl mb-4 text-gray-200 text-center">

                <a 
                  href="https://bookberry.club" 
                  className="inline-block bg-white text-[#8b123b] px-12 py-4 rounded-full text-xl font-bold hover:bg-gray-100 transition-colors duration-300"
                >
                  Visit bookberry
                </a>
                </p>
              </div>
            </div>

          </div>
        </div>
        
      </main>
      <Footer />
    </div>
  );
};

export default BerryClubLanding;